/*
 * @Author: Teemo Ding
 * @Date: 2022-03-23 14:45:01
 * @LastEditTime: 2022-08-04 16:41:06
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Customer/SenderInfo.tsx
 */
import React, { Fragment } from 'react';
import { get } from 'lodash';
import { useRequest } from 'ahooks';
import { Icon } from '@/src/tools/icon';
import { getSender, saveSender } from 'src/request/order';
import EditSenderInfo from '../EditSenderInfo';
import ModalHoc from 'src/constrains/ModalHOC';
import css from './css.module.less';
import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const SenderInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    disabled,
    customer,
    orderUuid,
    parcelSender,
    reLoadOrderPage,
    setParcelSender,
  } = props;
  const { run: _saveSender } = useRequest(
    (data) => saveSender(orderUuid, data),
    {
      manual: true,
      onSuccess: () => {
        handleCancel();
        if (reLoadOrderPage) reLoadOrderPage();
      },
    },
  );
  //sender弹窗
  const { run: _getSender } = useRequest(() => getSender(orderUuid), {
    manual: true,
    onSuccess: (data) => {
      handleShowModal(data);
    },
  });

  const handleShowModal = (data) => {
    setShowModal(true);
    setModalTitle(getI18n('allOrders.createneworder.editSenderInfo'));
    setWidth(600);
    setModalContent(
      <EditSenderInfo
        senderInfo={data}
        onCancel={handleCancel}
        onConfirm={onConfirm}
      />,
    );
  };
  const cbCreat = (data) => {
    setParcelSender(data);
    handleCancel();
  };
  const handleCancel = () => {
    setShowModal(false);
  };

  const onConfirm = (data) => {
    if (customer) {
      cbCreat(data);
    } else {
      _saveSender(data);
    }
  };

  const areaCodeUuid = get(parcelSender, 'areaCodeInfo.uuid');
  const areaCodeInText = useGetAreaCodeText(areaCodeUuid);

  return (
    <Fragment>
      <div className={css.customItem}>
        <h3>
          {getI18n('allOrders.createneworder.senderInfo')}{' '}
          {disabled ? (
            <Icon className={css.disable} type='iconedit' />
          ) : (
            <Icon
              onClick={() =>
                customer ? handleShowModal(parcelSender) : _getSender()
              }
              type='iconedit'
            />
          )}
        </h3>
        <span>{get(parcelSender, 'name')}</span>
        <span>
          +{areaCodeInText}
          {get(parcelSender, 'mobile')}
        </span>
        <span> {get(parcelSender, 'address')}</span>
        <span> {get(parcelSender, 'countryName')}</span>
        <span> {get(parcelSender, 'provinceName')}</span>
        <span> {get(parcelSender, 'postalCode')}</span>
      </div>
      <div className={css.splitLine}></div>
    </Fragment>
  );
};

export default ModalHoc(SenderInfo);
